import { api } from '@/services'

export const list = (params) => {
  return api.get('admin/hausefulUser/list', { params })
}

export const create = (hausefulUser) => {
  return api.post('admin/hausefulUser/create', hausefulUser)
}

export const update = (hausefulUser) => {
  return api.put(`admin/hausefulUser/update/${hausefulUser.id}`, hausefulUser)
}

export const fetchUser = (hausefulUserId) => {
  return api.get(`admin/hausefulUser/show/${hausefulUserId}`)
}

export const deleteUser = (hausefulUserId) => {
  return api.delete(`admin/hausefulUser/delete/${hausefulUserId}`)
}

export function createOnChecklist(id) {
  return api.post(`/admin/hausefulUser/createOnChecklist/${id}`)
}
